import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";

function UpdateUser({ id, onClose, onUserUpdated }) {
  const { authState } = useContext(AuthContext);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/${id}`,
          {
            headers: {
              "x-auth-token": authState.token,
            },
          }
        );
        const user = response.data;
        setFirstname(user.firstname);
        setLastname(user.lastname);
        setEmail(user.email);
      } catch (err) {
        toast.error("Failed to fetch user data.");
      }
    };
    fetchData();
  }, [id, authState.token]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${id}`,
        { firstname, lastname, email, password },
        {
          headers: {
            "x-auth-token": authState.token,
          },
        }
      );
      toast.success("User updated successfully.");
      onUserUpdated(response.data);
    } catch (err) {
      toast.error("Failed to update user.");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div className="w-full max-w-md p-8 bg-white rounded shadow-md">
        <h2 className="mb-4 text-2xl font-bold text-center">Update User</h2>
        <form onSubmit={handleUpdate}>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <div className="mb-4">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                First Name
              </label>
              <input
                type="text"
                className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Last Name
              </label>
              <input
                type="text"
                className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Email
            </label>
            <input
              type="email"
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Password (leave blank if unchanged)
            </label>
            <input
              type="password"
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="flex text-center gap-x-4">
            <button
              type="submit"
              className="w-full px-4 py-3 font-bold text-white bg-black rounded hover:bg-green-700 focus:outline-none focus:shadow-outline"
              style={{
                boxShadow: "11px 13px 28px 3px rgba(0,0,0,0.75)",
              }}
            >
              Update
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full px-4 py-3 font-bold text-white bg-red-600 rounded hover:bg-black focus:outline-none focus:shadow-outline"
              style={{
                boxShadow: "11px 13px 28px 3px rgba(0,0,0,0.75)",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </motion.div>
  );
}

export default UpdateUser;